export default __webpack_public_path__ + "static/bg_footer_sp-980f249a18f4dd27208b2a0a904b5e9f.png";